import React from "react";

import Dispatcher from "./Dispatcher";

import { useCurrentUserRoles } from "../Authorization";

const Dashboard = () => {
  const result = useCurrentUserRoles();
  const items = [];
  if (result.includes("DISP")) {
    items.push(Dispatcher);
  }
  return (
    <div className="main-dashboard">
      {items.map((Component, i) => (
        <Component key={i} />
      ))}
    </div>
  );
};

export default Dashboard;
